/**
 * Created by anair on 6/29/17.
 */

import 'whatwg-fetch';
import Cookies from 'js-cookie';

export function logMessageToServer(messageType, component, messageDesc) {
    let logMessage = {type:messageType,
                        component: component, messageDesc:
                        messageDesc};
    return fetch("/cloudUI/logs/api/v1/log", {
        method: "post",
        body: JSON.stringify(logMessage),
        credentials: "same-origin",
        headers: {"Content-Type": "application/json", "XSRF_TOKEN": Cookies.get('XSRF_TOKEN')}
    });
};
